module.exports = __webpack_public_path__ + "media/images/MRM-icon3-65fb467c.png";